import { SESSION_KEY_FLUXMED_CARD_HIGHLIGHT } from "../constants/crmSetupConfigurationOptions";

export function readFluxmedCardHighlightSessionFlag(): boolean {
  try {
    return (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(SESSION_KEY_FLUXMED_CARD_HIGHLIGHT) === "1"
    );
  } catch {
    return false;
  }
}
